module.exports = __webpack_public_path__ + "img/okx_grey_new.e3ca7a22.svg";